








import BookingDetail from "@/components/booking/customer/BookingDetail.vue";
import LayoutReportWithBanner from "@/layouts/LayoutReportWithBanner.vue";
import { AvailabilityModule } from "@/store/modules/availability.store";
import { Component, Vue } from "vue-property-decorator";
import { PartnerModule } from "@/store/modules/partner";
import { ReportModule } from "@/store/modules/report.store";
import { UserModule } from "@/store/modules/me-user.store";
import { AppContextEnum } from "@/lib/enum/appContext.enum";
import { ConfigModule } from "@/store/modules/config";

@Component({
  components: {
    LayoutReportWithBanner,
    BookingDetail
  }
})
export default class BookingDetailView extends Vue {
  get showLoginButton(): boolean {
    const isCustomerSignup = PartnerModule.partner?.settings?.bookedServices.customer ?? false;
    const isThg = ConfigModule.appContext === AppContextEnum.THG;
    return isThg ? !UserModule.isAuthenticated : !UserModule.isAuthenticated && isCustomerSignup;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  get bookingId() {
    return this.$route.params["id"];
  }

  get partnerId() {
    return ReportModule.partner?._id || PartnerModule.partner?._id;
  }

  async mounted() {
    const booking = await AvailabilityModule.findOneBookingByPartner({ partnerId: this.partnerId, id: this.bookingId });

    await AvailabilityModule.findOneByPartner({
      partnerId: this.partnerId,
      id: booking.serviceId || "",
      date: new Date().toISOString()
    });
  }
}
